export const SCROLLBAR_HARMONISATION_ATTRIBUTE = 'data-scrollbar-harmonisation';
export const SCROLLBAR_HARMONISATION_TRANSPARENT_ATTRIBUTE =
	'data-scrollbar-harmonisation-transparent';
